import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SecondDeliveryOrderTable from './SecondDeliveryOrderTable';
import {Box} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Dialog, DialogTitle, DialogContent, Divider } from '@material-ui/core';
import { handleSecondDelivery, openSecondDelivery, showAlertSnackbar } from '../../reducers/uiSlice';
import {Tooltip } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useTranslation } from 'react-i18next';
import { batchUpdateSecondDeliveryOrders, createSecondDeliveryBatch, fetchSecondDeliveryOrders } from '../../actions/secondDeliveryOrderActions';
import { getUserPreference } from '../../utilities/common';
import ActionSection from '../Common/ActionSection';
import { useAlert } from '../../utilities/hooks';
import { alertType } from '../Common/UniAlert/context';
import FullscreenLoading from '../Common/FullscreenLoading';
import TransferToDriver from './TransferToDriver';
import moment from 'moment';
import { getBranchList } from '../../actions/commonAction';
import DateRangeSearch from '../Common/DateRangeSearch';


const useStyles = makeStyles((theme) => ({
  section: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  boxStyle: {
    height: 750
  }
}));


export default function SecondDeliveryOrderList() {
  const classes = useStyles();
  const {t} = useTranslation('secondDelivery');
  const dispatch = useDispatch();
  const alertDialog = useAlert();
  const openModal = useSelector(openSecondDelivery);
  const userPref = getUserPreference();

  const secondDelivery = useSelector(state => state.secondDelivery)

  const [selectedOrders, setSelectedOrders] = useState([])
  const [dates, setDates] = useState({})
  const [openTransferDriver, setOpenTransferDriver] = useState(false);
  const [downloadExcel, setDownloadExcel] = useState([]);
  const [resAll, setResAll] = useState([]);
  const [branches, setBranches] = useState([]);
  const [branch, setBranch] = useState(userPref.userCity);

  const _handleSearch = (fromDate, toDate, branch) => {
    dispatch(fetchSecondDeliveryOrders(branch, fromDate, toDate, userPref.hideAssociatedOrders))
    .then((res) => {
      setResAll(res);
    })
    setDates({
      from: fromDate,
      to: toDate
    })
  }

  const _handleTransferToDriver = () => {
    if(selectedOrders.length <= 0){
      alertDialog.addAlertDialog(
        t('dialog:transfer_orders_title'), 
        t('dialog:transfer_orders_empty'))
      alertDialog.showAlert()
      return
    }
    setOpenTransferDriver(true);
  }

  const _handleCreateBatch = () => {
    if(selectedOrders.length <= 0){
      alertDialog.addAlertDialog(
        t('dialog:reschedule_create_batch_title'), 
        t('dialog:reschedule_create_batch_empty'))
      alertDialog.showAlert()
      return
    }
    alertDialog.addAlertDialog(
      t('dialog:reschedule_create_batch_title'), 
      t('dialog:reschedule_create_batch_message', {count: selectedOrders.length}),
      alertType.INFO,
      t('common:cancel'))
    alertDialog.addActionButton(
      t('common:confirm'), 
      ()=>{
        dispatch(createSecondDeliveryBatch(userPref.userCity, selectedOrders)).then((res) => {
          if(res && res.db_result){
            dispatch(showAlertSnackbar({
              type: 'success',
              title: t('dialog:reschedule_create_batch_title'),
              message: t('dialog:reschedule_create_batch_success', {subBatchNo: res.sub_batch_no})
            }))
            dispatch(fetchSecondDeliveryOrders(userPref.userCity, dates.from, dates.to, userPref.hideAssociatedOrders))
            alertDialog.hideAlert()
          }
        }).catch((error) => {
          dispatch(showAlertSnackbar({
            title: t('dialog:reschedule_create_batch_title'),
            message: error.message
          }))
        })
      }, 
      'primary')
    alertDialog.showAlert()
  }

  const _handleAutoDelivery = () => {
    alertDialog.addAlertDialog(
      t('dialog:auto_update_delivery_title'),
      t('dialog:auto_update_delivery_message'),
      alertType.INFO,
      t('common:cancel')
    )
    alertDialog.addActionButton(
      t('common:confirm'),
      () => {
        dispatch(batchUpdateSecondDeliveryOrders()).then((res) => {
          if(res && res.succ === 1){
            dispatch(showAlertSnackbar({
              type: 'success',
              title: t('dialog:auto_update_delivery_title'),
              message: t('dialog:auto_update_delivery_success'),
            }))
          }
          alertDialog.hideAlert()
        }).catch(error => {
          dispatch(showAlertSnackbar({
            title: t('dialog:auto_update_delivery_title'),
            message: t('dialog:auto_update_delivery_fail'),
          }))
        })
      },
      'primary'
    )
    alertDialog.showAlert()
  }

  useEffect(() => {
    if(openModal) {
      setDownloadExcel([]);
      dispatch(getBranchList()).then((branchesCurr)=>{
          setBranches(branchesCurr);
      })
      setBranch(userPref.userCity);
    }
  }, [openModal])
  useEffect(() => {
    if(selectedOrders.length > 0) {
      let downloadExcelCurr = [];
      selectedOrders.map((orderId) => {
        const selected = resAll.find(element => element.order_id + '' === orderId + '');
        const selectedCurr = JSON.parse(JSON.stringify(selected));
        selectedCurr.add_time = moment(selectedCurr.add_time * 1000).format('YYYY-MM-DD HH:mm:ss');
        downloadExcelCurr.push(selectedCurr);
      })
      setDownloadExcel(downloadExcelCurr);
    } else if(selectedOrders.length === 0) {
      setDownloadExcel([]);
    }
  }, [selectedOrders])

  return (
    <Dialog 
      onClose={handleClose} 
      open={openModal}
      fullWidth={true}
      maxWidth='lg'
    >    
      <TransferToDriver
        openTransferDriver={openTransferDriver} 
        handleDriverTransferClose={handleDriverTransferClose}
        selectedOrders={selectedOrders}
      />
      <DialogTitle>
          {t('title_second_delivery')}
          <Tooltip title={t('common:cancel')} aria-label="cancel" style={{float: "right"}}>
              <CloseIcon onClick={handleClose}></CloseIcon>
          </Tooltip>                                   
      </DialogTitle>
      <DialogContent dividers className={classes.boxStyle}>
        <Box style={{display: 'flex', flexDirection: 'column', height: '100%'}}>
          <div className={classes.section}>
            <DateRangeSearch 
              onSearchClick={_handleSearch}
              userCity={branch}
              branches={branches}
            />
          </div>
          <Divider />
          <div className={classes.section} style={{flexGrow: 1}}>
            <SecondDeliveryOrderTable 
              isLoading={secondDelivery.isOrdersLoading}
              orderListCurr={secondDelivery.orders}
              onOrderSelected={(orderIds)=>{setSelectedOrders(orderIds)}}
            />
          </div>
          <div className={classes.section}>
            <ActionSection 
              onCreateBatch={_handleCreateBatch}
              onAutoDelivery={_handleAutoDelivery}
              onTransferToDriver={_handleTransferToDriver}
              downloadExcel={downloadExcel}
            />
          </div>
        </Box>
      </DialogContent>
      <FullscreenLoading open={secondDelivery.isLoading}/>
    </Dialog>
  );

  /**
   * close the Transfer to Driver dialog
   */
  function handleDriverTransferClose() {
    setOpenTransferDriver(false);
  }

  /**
   * close the dialog
   */
   function handleClose() {
    dispatch(handleSecondDelivery(false))
  }
}
